import styled from 'styled-components';
import { goToTournament } from '../../../utils';
import { ImageUtils } from '../../../utils/ImageUtils';
import { tabStore } from '../../../store/tabStore';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from '../../../types/type';

export const ProgressTicket = ({
  ticketCnt,
  isMain,
  showWaringModal,
  isActiveTicket,
}: {
  ticketCnt: number;
  isMain: boolean;
  showWaringModal: () => void;
  isActiveTicket: boolean;
}) => {
  const { setMainTab, setSubTab } = tabStore();
  return (
    <>
      <Container>
        <ImgContainer>
          <QuestionIcon onClick={showWaringModal} />
          {isActiveTicket ? (
            <TicketImg
              $isActiveTicket={isActiveTicket}
              src={ImageUtils.ParticipateInfoActive}
              alt={'ParticipateInfoActive'}
            />
          ) : (
            <TicketImg
              src={isMain ? ImageUtils.ParticipateInfoMain : ImageUtils.ParticipateInfoSide}
              alt="ParticipateInfo"
            />
          )}
        </ImgContainer>
        <CountContainer>
          <CountCnt>
            {ticketCnt}
            <CountUnit>장</CountUnit>
          </CountCnt>
          <RemainContainer>
            <RemainText>남은 {isMain ? '메인' : '사이드'} 이벤트 참가 티켓</RemainText>
          </RemainContainer>
          <RemainSubText>
            참가 티켓은 <span>{isMain ? '18 TO 1' : '10 TO 1'}</span> 방식으로 지급되며,
            <br />
            {isMain ? '400' : '220'}장 모두 지급되면 새틀라이트가 조기종료 됩니다.
          </RemainSubText>

          {isActiveTicket ? (
            <>
              <CongratsText>축하합니다!</CongratsText>
              <CongratsSubText>
                {isMain ? '메인' : '사이드'} 이벤트 티켓을 획득했어요. <br />
                {isMain ? '메인' : '사이드'} 이벤트 참가 안내를 확인해주세요!
              </CongratsSubText>
            </>
          ) : (
            <>
              <NeedTicketContainer>
                <NeedTicketSubText>
                  {isMain ? '메인' : '사이드'} 이벤트 참가 티켓 획득 여부
                </NeedTicketSubText>
                <NeedTicketText>참가 티켓을 아직 획득하지 못했습니다.</NeedTicketText>
                <NeedTicketSubText>
                  {isMain ? '메인' : '사이드'} 새틀라이트를 통해 티켓을 획득해주세요!
                </NeedTicketSubText>
              </NeedTicketContainer>
            </>
          )}
        </CountContainer>
      </Container>
      <BottomTabContainer>
        {isActiveTicket ? (
          <>
            <GoTournamentBtn
              $isMain={isMain}
              onClick={() => {
                setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
                setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_OFFLINE);
              }}
            >
              오프라인 {isMain ? '메인' : '사이드'} 이벤트 확인하기
            </GoTournamentBtn>
          </>
        ) : (
          <>
            <HowToParticipateButton
              onClick={() => {
                setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
                setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_ONLINE);
              }}
            >
              <p>
                새틀라이트 <br />
                참가 방법
              </p>
            </HowToParticipateButton>
            <ParticipateSettleButton onClick={() => goToTournament()}>
              <p>새틀라이트 참가하기</p>
            </ParticipateSettleButton>
          </>
        )}
      </BottomTabContainer>
    </>
  );
};

const ImgContainer = styled.div`
  position: relative;
`;

const TicketImg = styled.img<{ $isActiveTicket?: boolean }>`
  width: 333px;
`;

const Container = styled.div`
  position: relative;
  padding-bottom: 180px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 720px) {
    padding-bottom: 130px;
  }
`;

const CountContainer = styled.div`
  position: absolute;
  top: 10px;
  width: 100%;
  text-align: center;
`;

const RemainContainer = styled.div`
  margin: 0 auto;
  margin-bottom: 9px;

  border-top: 1.5px solid rgba(0, 0, 0, 0.5);

  background: rgba(0, 0, 0, 0.1);

  width: 200px;
  height: 21px;
`;

const RemainText = styled.h3`
  font-weight: 800;
  letter-spacing: -0.02em;
  color: rgba(0, 0, 0, 0.7);
  font-size: 12px;
  line-height: 16px;
`;
const RemainSubText = styled.h4`
  letter-spacing: -0.03em;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;

  span {
    font-weight: 800;
  }
  font-size: 12px;
  line-height: 15px;
`;

const NeedTicketContainer = styled.div`
  margin-top: 35px;
`;

const NeedTicketText = styled.h3`
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #000000;
  font-size: 16px;
  line-height: 18px;
`;
const NeedTicketSubText = styled.h4`
  letter-spacing: -0.02em;
  color: rgba(0, 0, 0, 0.5);
  margin: 5px 0;
  font-size: 13px;
  line-height: 17px;
`;

const CountCnt = styled.p`
  font-weight: bold;
  font-size: 70px;
  line-height: 74px;
`;

const CountUnit = styled.span`
  font-size: 48px;
`;

const QuestionIcon = styled.div`
  position: absolute;
  right: 30px;
  cursor: pointer;
  z-index: 1;
  background-image: url(${ImageUtils.QuestionIcon});

  width: 25px;
  height: 25px;
  right: 10px;
  top: 20px;
  background-size: contain;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  height: 70px;
`;

const HowToParticipateButton = styled.button`
  background: rgba(169, 31, 82, 0.85);
  box-shadow: inset 0px 1px 0px rgba(255, 192, 192, 0.3);
  backdrop-filter: blur(30px);
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-weight: 900;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.04em;
    color: #ffffff;
    text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.5);
  }
`;

const ParticipateSettleButton = styled.button`
  background: rgba(139, 0, 67, 0.85);
  box-shadow: inset 0px 1px 0px rgba(255, 38, 201, 0.2);
  backdrop-filter: blur(30px);
  flex: 3;

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-weight: 900;
    font-size: 21px;
    line-height: 28px;
    letter-spacing: -0.04em;

    color: #ffffff;

    text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.5);
  }
`;

const CongratsText = styled.h3`
  font-weight: 900;
  letter-spacing: -0.02em;

  color: #d2006d;

  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 24px;
  line-height: 38px;
`;

const CongratsSubText = styled.h4`
  font-weight: 600;
  letter-spacing: -0.02em;

  color: #840053;
  font-size: 12px;
  line-height: 17px;
`;

const GoTournamentBtn = styled.button<{ $isMain: boolean }>`
  left: 30%;
  height: 70px;
  width: 100%;
  cursor: pointer;
  ${({ $isMain }) =>
    $isMain
      ? `
box-shadow: 0px 1px 0px 0px rgba(255, 183, 183, 0.3) inset;
background: linear-gradient(90deg, rgba(182, 0, 88, 0.85) 39.5%, rgba(174, 11, 114, 0.85) 100%);
backdrop-filter: blur(25px);`
      : `
background: linear-gradient(106deg, rgba(5, 91, 219, 0.90) -5.91%, rgba(16, 65, 139, 0.90) 72.35%);
box-shadow: 0px 1px 0px 0px rgba(31, 240, 255, 0.10) inset;
backdrop-filter: blur(30px);`}

  font-weight: 600;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;
